/**
 * Versions recorded against a user when they complete onboarding.
 *
 * These are the values the legacy app pinned in AuthService, carried over
 * verbatim so migrated users are not asked to re-accept terms they have
 * already accepted. The API stores whatever it is sent, so this file is the
 * only thing keeping the two apps in agreement — bump them here when the
 * terms or health acknowledgement actually change.
 */
export const CURRENT_TERMS_VERSION = "2026-04-08";
export const CURRENT_HEALTH_ACK_VERSION = "2026-05-03";
